<template>
  <div class="hot-companies-section">
    <div class="section-header">
      <h2 class="section-title">热门企业</h2>
      <slot name="extra"></slot>
    </div>

    <div v-if="loading" class="loading-state">
      <img src="@/assets/image/loading.png" alt="loading" />
    </div>

    <div v-else class="companies-grid">
      <div
        v-for="company in companies"
        :key="company.id || company.company_id"
        class="company-mini-card"
        @click="handleCompanyClick(company)"
      >
        <div class="company-card-header">
          <div class="company-logo-mini">
            <img :src="company.logo" :alt="company.company_full_name || company.company_name || company.name" />
          </div>
          <div class="company-card-body">
            <div class="company-name-mini" :title="company.company_full_name || company.company_name || company.name">
              {{ company.company_full_name || company.company_name || company.name }}
            </div>
            <div class="company-desc-mini text-truncate" :title="company.company_desc">
              {{ company.company_desc || '暂无介绍' }}
            </div>
            <div class="company-tags-mini">
              <span
                v-if="company.company_type"
                class="tag-mini text-truncate"
                :title="company.company_type"
              >
                {{ company.company_type }}
              </span>
              <span
                v-if="company.work_tags"
                class="tag-mini text-truncate"
                :title="company.work_tags"
              >
                {{ company.work_tags }}
              </span>
              <span
                v-if="company.business_status"
                class="tag-mini text-truncate"
                :title="company.business_status"
              >
                {{ company.business_status }}
              </span>
            </div>
          </div>
        </div>
        <div class="company-card-footer">
          <div class="hot-job-mini">
            <span>热招</span>
            <span class="text-truncate hotJob">
              {{ company.hot_job_title || '热门职位' }}
            </span>
            <span>
              {{ formatSalary(company.hot_job_salary_start, company.hot_job_salary_end, company.hot_job_salary_month) || company.hot_job_salary || '0-0k' }}
            </span>
          </div>
          <div class="job-count-mini">
            <span>在招职位{{ company.job_count || company.jobCount || 0 }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="view-more-wrapper" v-if="showMore">
      <button class="view-more-btn" @click="$emit('view-more')">查看更多企业</button>
    </div>
  </div>
</template>

<script>
import { getHotJob } from '@/api/recommend'
import { formatSalary } from '@/constants/jobConstants'

export default {
  name: 'HotCompanyGrid',
  props: {
    limit: { type: Number, default: 9 },
    requestParams: { type: Object, default: () => ({}) },
    showMore: { type: Boolean, default: true }
  },
  data() {
    return {
      companies: [],
      loading: false
    }
  },
  created() {
    this.fetchHotCompanies()
  },
  methods: {
    formatSalary,
    handleCompanyClick(company) {
      const companyId = company.company_id || company.companyId || company.id
      if (companyId) {
        this.$router.push({
          path: '/hot-jobs',
          query: { company_id: companyId }
        })
      }
    },
    async fetchHotCompanies() {
      if (this.loading) return
      this.loading = true
      try {
        const payload = {
          page_no: 1,
          page_size: this.limit,
          type: 2,
          ...this.requestParams
        }
        const res = await getHotJob(payload)
        if (res?.data?.code === 1) {
          const lists = res.data.data?.lists || res.data.data || []
          this.companies = lists.slice(0, this.limit)
        } else {
          this.companies = []
          console.error('获取热门企业失败:', res?.data?.msg)
        }
      } catch (error) {
        console.error('获取热门企业异常:', error)
        this.companies = []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.hot-companies-section {
  width: 100%;
  padding: 32px 0;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.section-title {
  font-size: 32px;
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
}

.loading-state {
  text-align: center;
  img {
    width: 360px;
  }
}

.companies-grid {
  width: 100%;
  max-width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  align-items: start;

  .company-mini-card {
    display: flex;
    flex-direction: column;
    width: 100%;
    box-shadow: 0 12px 32px rgba(136, 107, 255, 0.15);
    backdrop-filter: blur(18px);
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.7);
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      border-color: rgba(124, 65, 255, 0.4);
      box-shadow: 0 18px 36px rgba(124, 65, 255, 0.2);
    }

    .company-card-header {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 20px;
      padding-bottom:10px;
      border-radius: 12px 12px 0 0;
      background: rgba(255, 255, 255, 0.4);

      .company-logo-mini {
        width: 48px;
        border-radius: 4px;
        overflow: hidden;
        flex-shrink: 0;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .company-card-body {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 6px;
      }

      .company-name-mini {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        max-width: 14vw;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .company-desc-mini {
      font-size: 12px;
      color: #666;
      line-height: 1.5;
      max-width: 20vw;
      min-height: 18px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .company-tags-mini {
      display: flex;
      gap: 6px;
      margin-bottom:10px;
      height: 20px;

      .tag-mini {
        padding: 2px 8px;
        background: #f0f0f0;
        border-radius: 4px;
        font-size: 12px;
        color: #666;
        max-width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .company-card-footer {
      height: 52px;
      border-radius: 0 0 12px 12px;
      display: flex;
      padding-left: 20px;
      line-height: 42px;
      align-items: center;
      justify-content: space-between;
      background: rgba(255, 255, 255, 0.6);

      .hot-job-mini {
        font-size: 12px;
        color: #333;
        font-weight: 500;
        display: flex;

        .hotJob {
          max-width: 120px;
          display: inline-block;
          margin: 0 4px;
          background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          font-weight: 600;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .job-count-mini {
        min-width: 100px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 12px;
        background: url('~@/views/hot-jobs/assets/img/position.svg') no-repeat center / contain;

        span {
          font-size: 12px;
          font-weight: 600;
          background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }
      }
    }
  }
}

.text-truncate {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

@media (max-width: 1200px) {
  .companies-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .companies-grid {
    grid-template-columns: 1fr;
  }

  .company-desc-mini {
    max-width: 60vw;
  }
}

@media (max-width: 1200px) {
  .company-card-body {
    grid-template-columns: 180px 1fr 160px;
  }
}

@media (max-width: 992px) {
  .company-card-body {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .company-tags-mini {
    flex-wrap: wrap;
  }

  .companies-grid {
    gap: 16px;
  }
}

.view-more-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.view-more-btn {
  padding: 8px 98px;
  border-radius: 4px;
  border: none;
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
</style>
